import { render, staticRenderFns } from "./daily-backup.vue?vue&type=template&id=76f28f42"
import script from "./daily-backup.vue?vue&type=script&lang=js"
export * from "./daily-backup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports